import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'utils/react';
import { push as pushRoute } from 'react-router-redux';
import { getFlipper, getNonDefaultLocales } from 'store/modules/company';
import {
  load as loadAllPages,
  makeLive,
  makeDraft,
  switchLiveAndDraft,
  switchFacilityId,
  clone as clonePage,
  create as createPage,
  searchPages,
  updateFilters,
  getListViewPages,
  clearFilters,
} from 'store/modules/pages';
import {
  save as savePage,
  publish as publishPage,
} from 'store/modules/pageBuilder';
import {
  loadNavigation,
  build as buildSite,
  toggleAuthenticatedPages,
} from 'store/modules/site';
import get from 'lodash/get';
import {
  FLIPPER_ADMIN_LIST_VIEW,
  FLIPPER_INTERNATIONALIZATION,
} from '../../../../../constants/flippers';
import AdminHome from '../components/AdminHome';
import { saveRecipientEmail } from '../../../../web/store/modules/pages';

const mapStateToProps = state => ({
  pages: getListViewPages(state),
  selectedFilters: state.pages.filters,
  isLoading: state.clientMiddleware.loading !== 0,
  pageSet: state.site.pageSet,
  isSiteLoading: !!state.site.loading,
  builderListViewFeature: getFlipper(state, FLIPPER_ADMIN_LIST_VIEW),
  profile: get(state, 'user.auth'),
  onlyShowAuthenticated: state.site.onlyShowAuthenticated,
  languagesEnabled: getFlipper(state, FLIPPER_INTERNATIONALIZATION),
  nonDefaultLanguages: getNonDefaultLocales(state),
});
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({
    savePage,
    pushRoute,
    search: searchPages,
    updateFilters,
    toggleAuthenticatedPages,
    clearFilters,
    createPage,
  }, dispatch),
  publishPage: (page, pageId) =>
    dispatch(publishPage(page, pageId)).then(() =>
      dispatch(loadAllPages(true))),
  makeLive: page =>
    dispatch(makeLive(page)).then(() =>
      dispatch(loadNavigation())),
  makeDraft: page =>
    dispatch(makeDraft(page)).then(() =>
      dispatch(loadNavigation())),
  switchLiveAndDraft: (toMakeLive, toMakeDraft) =>
    dispatch(switchLiveAndDraft(toMakeLive, toMakeDraft)).then(() =>
      dispatch(loadNavigation())),
  switchFacilityId: (page, livePage) =>
    dispatch(switchFacilityId(page, livePage))
      .then(() => dispatch(loadAllPages(true)))
      .then(() => dispatch(loadNavigation())),
  onBuildSite: pageSet => dispatch(buildSite(pageSet)).then(() =>
    dispatch(loadAllPages())),
  saveAndReloadPages: page =>
    dispatch(savePage(page)).then(() =>
      dispatch(loadAllPages(true))),
  clonePage: page =>
    dispatch(clonePage(page)).then(() =>
      dispatch(searchPages())),
  saveRecipientEmail: ({ pageId, recipientEmail }) =>
    dispatch(saveRecipientEmail({ pageId, recipientEmail })),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(AdminHome);
